import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  course: {},
  topics: [],
  linearTopics: [],
  topicsMap: {},
  entity: {},
  entityUuid: '',
  mcSummary: {},
  mcSummaryForSelectedUser: {},
  competencySummary: {},
  competencySummaryForSelectedUser: {},
  continueLearning: {},
  continueLearningLast: [],
  classGrades: [],
  competencies: [],
  microcompetencies: [],
  classSummary: {},
  fullClassSummary: [],
  classSummaryWithPeer: {},
  childrenSummary: [],
  competencySummaryForClass: [],
  childrenCompetencySummaryForClass: [],
  bbCourseAccess: {},
  bbContentAccess: {},
  bbAnnouncements: {},
  bbGradeActivity: {},
  bbAggregatedGradeActivity: {},
  isTocOpen: false
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/course/vuex/index.js